import React, { useCallback, useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Badge,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetDegreeAction,
  GetStudentAction,
  GetStudentChatByIdAction,
  GetStudentNotesByIdAction,
  GetStudentReminderByIdAction,
} from "../../Redux/action/ApplicationAction";
import StudentChat from "../../Icon/StudentChat";
import Note from "../../Icon/Note";
import Reminder from "../../Icon/Reminder";
import PaymentsIcon from "@mui/icons-material/Payments";
import {
  GetAgentAction,
  GetOrganizationAction,
  GetProgramAction,
  GetUniversityAction,
} from "../../Redux/action/SettingAction";
import { EmailTwoTone } from "@mui/icons-material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "../../component/CopyToClipboard";
import { StudentChatModal } from "../../component/StudentModal/ChatModal.component";
import { StudentReminderModal } from "../../component/StudentModal/ReminderModal.component";
import { StudentNotesModal } from "../../component/StudentModal/NotesModal.component";
import { StudentVisaApproveModal } from "../../component/StudentModal/VisaApproveModal.component";
import FolderIcon from "@mui/icons-material/Folder";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import axios from "axios";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import { StudentTransferModal } from "../../component/StudentModal/StudentTransfer.component";
import { handleExport } from "../ExportFunction/ExportFunction";
import PushPinIcon from "@mui/icons-material/PushPin";
import { StudentPinnedModal } from "../../component/StudentModal/PinnedModal.component";
import MessageIcon from "@mui/icons-material/Message";
import DuplicateBadge from "./DuplicateBadge.component";
import {
  postmarkSeenMessagesAPI,
  postmarkSeenMessagesStdAPI,
  updateStudentIsNewStatusAPI,
} from "../../Redux/service/Application";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import DraftsIcon from "@mui/icons-material/Drafts";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import { CustomPagination } from "../../component/datatable/CustomPagination";
import { BulkUploadModal } from "../../component/Modal/BulkUploadModal";
import { DownloadBulkUploadTemplateModal } from "../../component/StudentModal/DownloadBulkUploadTemplateModal";
import { toTitleCase, toTitleCaseRequired } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";
import SOCKET_EVENTS from "../../socket/events";
import { connectSocket } from "../../socket/socketClient";


const sortStudentList = (list) => {
  return [...(list || [])].sort((a, b) => {
    // 1. Pinned student first (isPined === true)
    const aPin = a.isPined ? 1 : 0;
    const bPin = b.isPined ? 1 : 0;
    if (aPin !== bPin) return bPin - aPin;

    // 2. isNew = false (Unseen / new) next
    const aUnseen = a.isNew === false ? 1 : 0;
    const bUnseen = b.isNew === false ? 1 : 0;
    if (aUnseen !== bUnseen) return bUnseen - aUnseen;

    // 3. Unread message count next
    const aCount = Number(a.count || 0);
    const bCount = Number(b.count || 0);
    if ((aCount > 0) !== (bCount > 0)) {
      return bCount > 0 ? 1 : -1;
    }
    if (aCount > 0 && bCount > 0 && aCount !== bCount) {
      return bCount - aCount;
    }

    // 4. Default: by entry date / createdOn / createdAt descending
    const aDate = new Date(
      a.createdOn || a.createdAt || a.updatedAt || 0
    ).getTime();
    const bDate = new Date(
      b.createdOn || b.createdAt || b.updatedAt || 0
    ).getTime();
    return bDate - aDate;
  });
};

const StudentlistPage = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [Studentlist, setStudentlist] = useState([]);

  const [uploadTemplateModal, setUploadTemplateModal] = useState(false);

  const [table_load, setTable_load] = useState(false);

  const [chatModal, setChatModal] = useState(false);

  const [NoteModal, setNoteModal] = useState(false);

  const [ReminderModal, setReminderModal] = useState(false);

  const [stdId, setStdId] = useState("");

  const [visibleColumns, setVisibleColumns] = useState([]);

  const [AddPaymentModal, setAddPaymentModal] = useState(false);

  const [selectionModel, setSelectionModel] = useState([]);

  const [Degreelist, setDegreelist] = useState([]);
  const [Organizationlist, setOrganizationlist] = useState([]);
  const [Agentlist, setAgentlist] = useState([]);

  const [Universitylist, setUniversitylist] = useState([]);
  const [Programlist, setProgramlist] = useState([]);

  const [data, setData] = useState([]);
  const [isFilterOpen, setFilterOpen] = useState(false);

  const [TransferModal, setTransferModal] = useState(false);

  const [pinnedModal, setPinnedModal] = useState(false);
  const [pinned, setPinned] = useState();
  const [isPinedNotes, setisPinedNotes] = useState();

  const [BulkModal, setBulkModal] = React.useState(false);
  const [anchorElBulk, setAnchorElBulk] = React.useState(null);
  const openbulk = Boolean(anchorElBulk);
  const handleBulkClick = (event) => {
    setAnchorElBulk(event.currentTarget);
  };
  const handleBulkClose = () => {
    setAnchorElBulk(null);
  };

  const [loading, setLoading] = useState(true);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 5,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    console.log(page);
    let data = {
      page: page,
      limit: pagination.limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };
  const [limit, setLimit] = useState(25);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleMenuClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null);
  };

  const handleAction = (action) => {
    console.log(`Action "${action}" on row ID: ${selectedRowId}`);
    handleMenuClose();
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const handlePinnedModal = () => {
    setPinnedModal(!pinnedModal);
  };
  const UniversitylistState = useSelector(
    (state) => state.setting?.university?.data?.universities
  );

  const handleVisibleColumnsChange = useCallback((visibleColumns) => {
    console.log("handele visible", visibleColumns);
    // Handle the change in visible columns
    setVisibleColumns(visibleColumns);
  }, []);

  useEffect(() => {
    const updatedData = UniversitylistState?.map(({ name, ...rest }) => ({
      title: name,
      ...rest,
    }));
    setUniversitylist(updatedData);
  }, [UniversitylistState]);

  const ProgramlistState = useSelector(
    (state) => state.setting?.program?.data?.programs
  );

  useEffect(() => {
    setProgramlist(
      ProgramlistState?.map(({ program, ...rest }) => ({
        title: program,
        ...rest,
      }))
    );
  }, [ProgramlistState]);

  const DegreelistState = useSelector(
    (state) => state.application?.degree?.data?.degrees
  );

  const OrganizationlistState = useSelector(
    (state) => state.setting?.organization?.data?.organizations
  );

  const AgentlistState = useSelector(
    (state) => state.setting?.agent?.data?.activeAgents
  );
  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    dispatch(GetDegreeAction());
    dispatch(GetOrganizationAction(data));
    dispatch(GetAgentAction());
  }, []);

  useEffect(() => {
    setDegreelist(
      DegreelistState?.map(({ name, ...rest }) => ({
        title: name,
        ...rest,
      }))
    );

    setOrganizationlist(
      OrganizationlistState?.map(({ organizationName, ...rest }) => ({
        title: organizationName,
        ...rest,
      }))
    );

    setAgentlist(
      AgentlistState?.map(({ firstName, ...rest }) => ({
        title: firstName,
        ...rest,
      }))
    );
  }, [DegreelistState, OrganizationlistState, AgentlistState]);

  const columns = [
    {
      field: "pinned",
      headerName: "",
      width: 50,
      renderCell: (params) => {
        const handlePinned = (e) => {
          e.stopPropagation();
          setStdId(params.row.id);
          setPinned(params.row.isPined);
          setisPinedNotes(params.row.isPinedNotes);
          handlePinnedModal();
        };
        return (
          <Box className="d-flex align-items-center h-100">
            <IconButton
              onClick={handlePinned}
              size="small"
              title={params.row.isPined ? "Pinned (Click to edit/unpin)" : "Click to pin"}
            >
              <PushPinIcon
                sx={{
                  fill: params.row.isPined ? ThemeColor.RED : ThemeColor.GREY,
                }}
              />
            </IconButton>
          </Box>

        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        const handleChatActionClick = async (event) => {
          event.stopPropagation(); // Prevent the row from being selected when clicking the icon
          const rowStudentId = params.row.id || params.row._id;
          setStdId(rowStudentId);
          setChatModal(true);
          handleMenuClose();


          // Immediately clear the unread badge locally for instant UI response
          setData((prev) =>
            (prev || []).map((r) =>
              String(r.id || r._id) === String(rowStudentId)
                ? { ...r, count: 0 }
                : r
            )
          );
          setStudentlist((prev) =>
            (prev || []).map((r) =>
              String(r.id || r._id) === String(rowStudentId)
                ? { ...r, count: 0 }
                : r
            )
          );

          await postmarkSeenMessagesStdAPI(rowStudentId)
            .then((res) => {
              if (res.status === 200) {
                // reload();
              }

              return null;
            })
            .catch((err) => {
              console.log(err);
            });
          dispatch(GetStudentChatByIdAction(rowStudentId));
        };

        const handleNoteActionClick = (e) => {
          e.stopPropagation();
          //(params.row.id);
          setStdId(params.row.id);
          setNoteModal(true);
          handleMenuClose();

          dispatch(GetStudentNotesByIdAction(params.row.id));
        };

        const handleReminderActionClick = (e) => {
          e.stopPropagation();
          setStdId(params.row.id);
          setReminderModal(true);
          handleMenuClose();

          dispatch(GetStudentReminderByIdAction(params.row.id));
        };

        const handleEditActionClick = (event) => {
          event.stopPropagation();
          setAddPaymentModal(true);
          handleMenuClose();

          setStdId(params.row.id);
        };

        const handleEmailActionClick = (event) => {
          event.stopPropagation();
          handleMenuClose();

          navigate(`/CAE/StudentMailTemplate/${params.row.agent.email}`);
        };

        const handleEditApplicantActionClick = (event) => {
          event.stopPropagation();
          handleMenuClose();

          const studentId = params.row.id;
          // Automatically mark as seen when opening details / edit page
          setData((prev) => {
            const updated = (prev || []).map((r) =>
              String(r.id || r._id) === String(studentId)
                ? { ...r, isNew: true }
                : r
            );
            return sortStudentList(updated);
          });
          setStudentlist((prev) => {
            const updated = (prev || []).map((r) =>
              String(r.id || r._id) === String(studentId)
                ? { ...r, isNew: true }
                : r
            );
            return sortStudentList(updated);
          });
          updateStudentIsNewStatusAPI(studentId, true).catch(() => {});

          navigate(`/CAE/EditApplication/${studentId}`);
        };

        const handleToggleSeenActionClick = async (event) => {
          event.stopPropagation();
          handleMenuClose();

          const studentId = params.row.id;
          const currentIsNew = Boolean(params.row.isNew);
          const nextIsNew = !currentIsNew;

          // Update local state immediately for instant UI feedback
          setData((prev) => {
            const updated = (prev || []).map((r) =>
              String(r.id || r._id) === String(studentId)
                ? { ...r, isNew: nextIsNew }
                : r
            );
            return sortStudentList(updated);
          });
          setStudentlist((prev) => {
            const updated = (prev || []).map((r) =>
              String(r.id || r._id) === String(studentId)
                ? { ...r, isNew: nextIsNew }
                : r
            );
            return sortStudentList(updated);
          });


          try {
            await updateStudentIsNewStatusAPI(studentId, nextIsNew);
          } catch (err) {
            console.error("Failed to update student seen status:", err);
          }
        };

        const handleTogglePinActionClick = (event) => {
          event.stopPropagation();
          handleMenuClose();
          setStdId(params.row.id);
          setPinned(params.row.isPined);
          setisPinedNotes(params.row.isPinedNotes);
          handlePinnedModal();
        };

        const handleFolderActionClick = (event) => {
          event.stopPropagation();
          handleMenuClose();

          navigate(`/CAE/FileManager/StdFolder/${params.row.folderId?._id}`);
        };
        return (
          <Box className="d-flex w-100 h-100 justify-content-start align-items-center">
            <IconButton onClick={(e) => handleMenuClick(e, params.row.id)}>
              <Badge badgeContent={params.row.count} color="primary">
                <MoreVertIcon />
              </Badge>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && selectedRowId === params.row.id}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  borderRadius: "10px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
                  minWidth: "220px",
                  py: 0.5,
                }
              }}
            >
              <MenuItem onClick={handleEditApplicantActionClick} sx={{ gap: 1.5, py: 1 }}>
                <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  Edit Student
                </Typography>
              </MenuItem>

              <MenuItem onClick={handleChatActionClick} sx={{ gap: 1.5, py: 1 }}>
                <Badge badgeContent={params.row.count} color="primary">
                  <MessageIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                </Badge>
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  Chat
                </Typography>
              </MenuItem>

              {(window.sessionStorage.getItem("user_role_type") === "user" ||
                window.sessionStorage.getItem("user_role_type") === "admin") && (
                <MenuItem onClick={handleNoteActionClick} sx={{ gap: 1.5, py: 1 }}>
                  <Note />
                  <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                    Add Notes
                  </Typography>
                </MenuItem>
              )}

              <MenuItem onClick={handleReminderActionClick} sx={{ gap: 1.5, py: 1 }}>
                <Reminder />
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  Add Reminder
                </Typography>
              </MenuItem>

              <MenuItem onClick={handleEditActionClick} sx={{ gap: 1.5, py: 1 }}>
                <PaymentsIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  Approve Visa
                </Typography>
              </MenuItem>

              <MenuItem onClick={handleEmailActionClick} sx={{ gap: 1.5, py: 1 }}>
                <EmailTwoTone sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  Send Email
                </Typography>
              </MenuItem>

              <MenuItem onClick={handleToggleSeenActionClick} sx={{ gap: 1.5, py: 1 }}>
                {params.row.isNew ? (
                  <MarkEmailUnreadIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                ) : (
                  <DraftsIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                )}
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  {params.row.isNew ? "Mark as Unseen" : "Mark as Seen"}
                </Typography>
              </MenuItem>

              <MenuItem onClick={handleTogglePinActionClick} sx={{ gap: 1.5, py: 1 }}>
                <PushPinIcon
                  sx={{
                    fill: params.row.isPined ? ThemeColor.RED : ThemeColor.LIGHTPURPLE,
                    fontSize: 20,
                  }}
                />
                <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                  {params.row.isPined ? "Edit Pin / Unpin" : "Pin Student"}
                </Typography>
              </MenuItem>

              {window.sessionStorage.getItem("user_role_type") !== "agent" && (
                <MenuItem onClick={handleFolderActionClick} sx={{ gap: 1.5, py: 1 }}>
                  <FolderIcon sx={{ fill: ThemeColor.LIGHTPURPLE, fontSize: 20 }} />
                  <Typography fontFamily={FontFamily.Poppins} fontSize="0.875rem" fontWeight={500}>
                    Student Folder
                  </Typography>
                </MenuItem>
              )}
            </Menu>
          </Box>
        );
      },
    },

    {
      field: "createdOn",
      headerName: "Entry Date",
      width: 150,
      renderCell: (params) => {
        return <div>{dayjs(params.row.createdOn).format("MM-DD-YYYY")}</div>;
      },
    },
    ...(!(
      window.sessionStorage.getItem("user_role_type") === "agent" &&
      (window.sessionStorage.getItem("role") === "agent_counsellor" ||
        window.sessionStorage.getItem("role") === "counsellor")
    )
      ? [
        {
          field: "agent.firstName",
          headerName: "Agent",
          width: 150,
          renderCell: (params) => {
            return <div>{params.row?.agent?.firstName}</div>;
          },
        },
      ]
      : []),

    ...(window.sessionStorage.getItem("user_role_type") !== "agent"
      ? [
        {
          field: "organizationId.organizationName",
          headerName: "Organization",
          width: 150,
          renderCell: (params) => {
            return (
              <div>
                <Tooltip
                  title={params.row.organizationId?.organizationName}
                  arrow
                >
                  <span>
                    {params.row.organizationId?.organizationName}
                  </span>
                </Tooltip>
              </div>
            );
          },
        },
      ]
      : []),

    {
      field: "studentFirstName",
      headerName: "Student Name",
      width: 250,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100" mt={0.5}>
            <Typography fontSize={"0.85rem"} fontWeight={params.row?.isNew === false ? 700 : 400}>
              <div className="" style={{}}>
                {" "}
                {toTitleCase(
                  params.row?.studentFirstName +
                  " " +
                  params.row?.studentLastName
                )}
              </div>
              {(window.sessionStorage.getItem("user_role_type") === "admin" ||
                window.sessionStorage.getItem("user_role_type") === "user") &&
                params.row?.isDuplicate && (
                  <DuplicateBadge row={params.row} />
                )}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "university.name",
      headerName: "University",
      width: 250,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip title={params.row.university?.name} arrow>
              <span>
                {toTitleCase(params.row.university?.name)}
                {/* {params.row.university?.name.length > 5
                  ? `${params.row.university?.name.slice(0, 10)}...`
                  : params.row.university?.name} */}
              </span>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "degreeType.name",
      headerName: "Degree",
      width: 150,
      renderCell: (params) => {
        return <div>{params.row.degreeType?.name}</div>;
      },
    },
    {
      field: "program.program",
      headerName: "Program",
      width: 250,
      renderCell: (params) => {
        return <div>{params.row.program?.program}</div>;
      },
    },



    {
      field: "universityId",
      headerName: "Student ID",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            <Tooltip title={params.row.universityId} arrow>
              <span style={{ width: "1px" }}>
                {/* {params.row.universityId.length > 5
                  ? `${params.row.universityId.slice(0, 10)}...`
                  : params.row.universityId} */}
                {params.row.universityId}

              </span>
              {params.row?.universityId && (
                <IconButton
                  onClick={() => CopyToClipboard(params.row.universityId)}
                >
                  <ContentCopyIcon />
                </IconButton>
              )}
            </Tooltip>
          </div>
        );
      },
    },


    {
      field: "taggingStatus",
      headerName: "Tagging Status",
      width: 100,
      renderCell: (params) => {
        return (
          <div>
            {toTitleCaseRequired(params.row.taggingStatus)}

          </div>
        );
      },
    },
    {
      field: "latestNotes",
      headerName: "Remarks",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <Box className="d-flex align-items-center h-100" mt={0.5}>
            <Tooltip title={params.row?.latestNotes}>
              <Typography align="" fontSize={"0.85rem"}>
                <div className="" style={{}}>
                  {" "}
                  {toTitleCase(
                    params.row?.latestNotes
                      ? params.row.latestNotes.substring(0, 100) + "..."
                      : ""
                  )}
                </div>
              </Typography>
            </Tooltip>

          </Box>
        );
      },
    },

    {
      field: "intake",
      headerName: "Intake",
      width: 100,
      renderCell: (params) => {
        return (
          <div>
            {toTitleCaseRequired(params.row.intake)}

          </div>
        );
      },
    },

    {
      field: "applicationStatus",
      headerName: "Application Status",
      width: 100,
      renderCell: (params) => {
        return (
          <div>
            {toTitleCaseRequired(params.row.applicationStatus)}

          </div>
        );
      },
    },

    // 

    {
      field: "visaStatus",
      headerName: "Visa Status",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.visaStatus?.split("_").map((data) => {
              let string = toTitleCase(data) + " ";
              return string;
            })}
          </div>
        );
      },
    },
    {
      field: "commissionStatus",
      headerName: "Commission Status",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.commissionStatus?.split("_").map((data) => {
              let string = toTitleCase(data) + " ";
              return string;
            })}
          </div>
        );
      },
    },




    {
      field: "action3",
      headerName: "Add University",
      width: 150,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/AddUniversityApplication/${params.row.id}`);
        };
        return (
          <div
            className="d-flex"
            onClick={handleEditActionClick}
            style={{
              textDecoration: "underline",
              color: ThemeColor.LIGHTPURPLE,
              cursor: "grab",
            }}
          >
            Add More University
          </div>
        );
      },
    },
  ];

  const fields = [
    ...(!(
      window.sessionStorage.getItem("user_role_type") === "agent" &&
      (window.sessionStorage.getItem("role") === "agent_counsellor" ||
        window.sessionStorage.getItem("role") === "counsellor")
    )
      ? [
        {
          label: "Agent",
          value: "agentId",
          type: "multi-select",
          option: Agentlist,
        },
      ]
      : []),
    {
      label: "University",
      value: "university",
      type: "multi-select",
      option: Universitylist,
    },
    {
      label: "Program",
      value: "program",
      type: "multi-select",
      option: Programlist,
    },
    {
      label: "Degree Type",
      value: "degreeType",
      type: "multi-select",
      option: Degreelist,
    },
    {
      label:"Show Duplicate",
      value:"duplicate",
      type:"select",
      option:[{title:"Yes",_id:1},{title:"No",_id:0}]
    },
    {
      label: "Unread Messages",
      value: "unreadMessages",
      type: "select",
      option: [
        { title: "With Unread Messages", _id: "true" },
        { title: "No Unread Messages", _id: "false" },
      ],
    },
    {
      label: "Seen Status (isNew)",
      value: "isNew",
      type: "select",
      option: [
        { title: "Unseen (New)", _id: "false" },
        { title: "Seen", _id: "true" },
      ],
    },
    {
      label: "Pinned Status",
      value: "isPined",
      type: "select",
      option: [
        { title: "Pinned Only", _id: "true" },
        { title: "Unpinned Only", _id: "false" },
      ],
    },
    {
      label: "Application Status",
      value: "applicationStatus",
      type: "multi-select",
      option: [
        {
          _id: "application_submitted",
          title: "Application Submitted",
        },
        {
          _id: "application_not_submitted",
          title: "Application Not Submitted",
        },
        {
          _id: "application_incomplete",
          title: "Application Incomplete",
        },
        {
          _id: "decision_awaited",
          title: "Decision Waited",
        },
        { _id: "admitted", title: "Admitted" },
        {
          _id: "admitted_and_finalized",
          title: "Admitted and Finalized",
        },
        {
          _id: "admitted_but_not_finalized",
          title: "Admitted but not finalized",
        },
        { _id: "deferred", title: "Deferred" },
        { _id: "denied", title: "Denied" },
        { _id: "withdrawn", title: "Withdrawn" },
      ],
    },
    {
      label: "Tagging Status",
      value: "taggingStatus",
      type: "multi-select",
      option: [
        { _id: "tagged", title: "Tagged" },
        { _id: "not_tagged", title: "Not Tagged" },
        {
          _id: "awaited",
          title: "Awaited",
        },
      ],
    },
    {
      label: "Visa Status",
      value: "visaStatus",
      type: "multi-select",
      option: [
        {
          _id: "visa_approved",
          title: "Visa Approved",
        },
        {
          _id: "visa_rejected",
          title: "Visa Rejected",
        },
        { _id: "deferred", title: "Deferred" },
        { _id: "awaited", title: "Awaited" },
        {
          _id: "transferred",
          title: "Transferred/Dropped",
        },
        {
          _id: "pending",
          title: "Pending",
        },
      ],
    },
    ...(window.sessionStorage.getItem("user_role_type") !== "agent"
      ? [
        {
          label: "Organization",
          value: "organizationId",
          type: "multi-select",
          option: Organizationlist,
        },
      ]
      : []),
    { label: "StudentId/UniversityId", value: "universityId", type: "text" },
    { label: "Application Id", value: "referenceId", type: "text" },
    { label: "Intake", value: "intake", type: "text" },

    {
      label: "Commission Status",
      value: "commissionStatus",
      type: "multi-select",
      option: [
        {
          _id: "not_approved",
          title: "Commission Not Approved",
        },
        {
          _id: "approved",
          title: "Commission Approved",
        },
        {
          _id: "pending",
          title: "Commission Pending",
        },
      ],
    },
  ];
  const fetchData = async (filters) => {
    let string = (filters || [])
      .map((data) => {
        if (
          !data.field ||
          data.value === "" ||
          data.value === undefined ||
          data.value === null
        ) {
          return null;
        }
        if (data.field === "duplicate") {
          return `${data.field}=${data.value == 1 ? "Y" : "N"}`;
        } else {
          return `${data.field}=${encodeURIComponent(data.value)}`;
        }
      })
      .filter(Boolean);

    try {
      let queryString = string.length > 0 ? `&${string.join("&")}` : "";
      let response = await axios.get(
        basicurl +
          `/api/student/get-all-students?limit=${0}&page=${1}${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPagination(response.data?.pagination);
      const studentData =
        response.data.students?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
          count: rest.count ?? (rest.latestUnseenMessageDate ? 1 : 0),
        })) || [];
      const sortedData = sortStudentList(studentData);
      setData(sortedData);
      setStudentlist(sortedData);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetStudentAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetStudentAction(data));
  };

  const handleApplyFilters = applyFilters;

  const StudentlistState = useSelector(
    (state) => state.application?.student?.data
  );

  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (StudentlistState) {
      // const { data, pagination } = StudentlistState;
      // setRows(data);
      setPagination(StudentlistState?.pagination);
    }
  }, [StudentlistState]);
  // console.log(StudentlistState)
  useEffect(() => {
    let data = {
      page: 1,
      limit: 0,
    };
    setTable_load(true);
    // Through `reload` so that arriving back from a student's page - where the
    // filters are restored from the history entry - loads the same filtered
    // view instead of the full list.
    reload({ page: 1, limit: 25 });
    dispatch(GetUniversityAction(data));
    // all programs (no university filter) for the Program filter dropdown
    dispatch(GetProgramAction(undefined, data));
    setTable_load(false);
  }, []);

  // useEffect(() => {
  //   const updatedData = StudentlistState?.map(({ _id, ...rest }) => ({
  //     id: _id,
  //     ...rest,
  //   }));
  //   setStudentlist(updatedData);
  //   setTable_load(false);
  //   setData(updatedData);
  // }, [StudentlistState]);

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    const fetchChatCounts = async () => {
      const updatedChatList = await Promise.all(
        StudentlistState?.students?.map(async (chat) => {
          try {
            const response = await axios.get(
              `${basicurl}/api/chat-room/getUnseenMessageCount/${chat._id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            return {
              ...chat,
              id: chat._id,
              count: response.data?.unseenMessageCount,
            }; // Assume the API response has a 'count' field
          } catch (error) {
            // console.error(`Error fetching count for chat ID ${chat.id}`, error);
            return { ...chat, id: chat._id, count: 0 };
          }
        })
      );

      // Checked again here, not just when the effect started: this awaits one
      // request per row, so a filter applied while it was in flight would
      // otherwise be undone the moment it lands.
      if (getFilters().length > 0) {
        setTable_load(false);
        return;
      }

      const sortedChatList = sortStudentList(updatedChatList);
      setStudentlist(sortedChatList);
      setTable_load(false);
      setData(sortedChatList);
    };
    if (StudentlistState && StudentlistState?.students?.length > 0)
      fetchChatCounts();
  }, [StudentlistState]);

  // Real-time unread message counter sync over WebSocket
  useEffect(() => {
    const socket = connectSocket();
    if (!socket) return;

    const handleUnreadUpdate = (payload) => {
      if (!payload?.studentId) return;
      const targetId = String(payload.studentId);
      const newCount = Number(payload.unseenMessageCount || 0);

      setData((prevData) => {
        const updated = (prevData || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, count: newCount }
            : row
        );
        return sortStudentList(updated);
      });

      setStudentlist((prevList) => {
        const updated = (prevList || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, count: newCount }
            : row
        );
        return sortStudentList(updated);
      });
    };

    const handleStudentIsNewUpdate = (payload) => {
      if (!payload?.studentId) return;
      const currentRoleType = window.sessionStorage.getItem("user_role_type");
      const isCae = ["admin", "user", "sub_admin"].includes(currentRoleType);

      if (payload.targetRole === "cae" && !isCae) return;
      if (payload.targetRole === "agent" && isCae) return;

      const targetId = String(payload.studentId);
      const newStatus = Boolean(payload.isNew);

      setData((prevData) => {
        const updated = (prevData || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, isNew: newStatus }
            : row
        );
        return sortStudentList(updated);
      });

      setStudentlist((prevList) => {
        const updated = (prevList || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, isNew: newStatus }
            : row
        );
        return sortStudentList(updated);
      });
    };

    const handleStudentPinnedUpdate = (payload) => {
      if (!payload?.studentId) return;
      const currentRoleType = window.sessionStorage.getItem("user_role_type");
      const isCae = ["admin", "user", "sub_admin"].includes(currentRoleType);

      if (payload.targetRole === "cae" && !isCae) return;
      if (payload.targetRole === "agent" && isCae) return;

      const targetId = String(payload.studentId);
      const newPinned = Boolean(payload.isPined);
      const newNotes = payload.isPinedNotes || "";

      setData((prevData) => {
        const updated = (prevData || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, isPined: newPinned, isPinedNotes: newNotes }
            : row
        );
        return sortStudentList(updated);
      });

      setStudentlist((prevList) => {
        const updated = (prevList || []).map((row) =>
          String(row.id || row._id) === targetId
            ? { ...row, isPined: newPinned, isPinedNotes: newNotes }
            : row
        );
        return sortStudentList(updated);
      });
    };

    socket.on(SOCKET_EVENTS.STUDENT_CHAT_UNREAD_UPDATE, handleUnreadUpdate);
    socket.on(SOCKET_EVENTS.STUDENT_IS_NEW_UPDATE, handleStudentIsNewUpdate);
    socket.on(SOCKET_EVENTS.STUDENT_PINNED_UPDATE, handleStudentPinnedUpdate);

    return () => {
      socket.off(SOCKET_EVENTS.STUDENT_CHAT_UNREAD_UPDATE, handleUnreadUpdate);
      socket.off(SOCKET_EVENTS.STUDENT_IS_NEW_UPDATE, handleStudentIsNewUpdate);
      socket.off(SOCKET_EVENTS.STUDENT_PINNED_UPDATE, handleStudentPinnedUpdate);
    };
  }, []);




  // handle close of modal

  const handleCloseChatModal = () => setChatModal(!chatModal);
  const handleCloseReminderModal = () => setReminderModal(!ReminderModal);
  const handleCloseNoteModal = () => setNoteModal(!NoteModal);
  const handleCloseTransferModal = () => setTransferModal(!TransferModal);
  const handleCloseVisaApproveModal = () =>
    setAddPaymentModal(!AddPaymentModal);

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
            <Grid container spacing={2} alignItems="center" sx={{ overflow: "hidden" }}>
            <Grid item lg={3} md={3} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  Application List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={9} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() =>
                    handleExport(
                      selectionModel,
                      "Application",
                      data,
                      "isDisabled",
                      visibleColumns
                    )
                  }
                >
                  Export
                </OutlineCustomButton>

                {window.sessionStorage.getItem("user_role_type") === "agent" &&
                  (window.sessionStorage.getItem("role") === "admin" ||
                    window.sessionStorage.getItem("role") ===
                      "application_supervisor") && (
                    <OutlineCustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.PURPLE}
                      onClick={() => setTransferModal(true)}
                    >
                      Transfer
                    </OutlineCustomButton>
                  )}

                <FilterComponent
                  open={isFilterOpen}
                  onClose={() => setFilterOpen(false)}
                  onApply={handleApplyFilters}
            initialFilters={activeFilters}
                  fields={fields}
                />
                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  window.sessionStorage.getItem("user_role_type") === "user") && (
                  <>
                    <CustomButton
                      variant="contained"
                      type="submit"
                      backgroundColor={ThemeColor.YELLOW}
                      color={ThemeColor.WHITE}
                      onClick={handleBulkClick}
                    >
                      Bulk Update
                    </CustomButton>
                    <Menu
                      id="demo-positioned-menu"
                      aria-labelledby="demo-positioned-button"
                      anchorEl={anchorElBulk}
                      open={openbulk}
                      onClose={handleBulkClose}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem
                        onClick={() =>
                          setUploadTemplateModal(!uploadTemplateModal)
                        }
                      >
                        Download Template
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setBulkModal(!BulkModal);
                        }}
                      >
                        Upload Data (Bulk)
                      </MenuItem>
                    </Menu>
                  </>
                )}
                <CustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  color={ThemeColor.WHITE}
                  onClick={() => navigate("/CAE/CreateApplication")}
                >
                  Add Student
                </CustomButton>
              </Box>
            </Grid>
          </Grid>

          <div className="table-container " style={{ overflow: "hidden" }}>
            <CustomDataTable
              row={data ? data : []}
              columns={columns}
              loading={table_load}
              rowheight={70}
              onSelectionChange={(newSelection) => {
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) => {
                const baseClass =
                  params.row.isDisabled === true ? "row-dull" : "row-white";
                const seenClass =
                  params.row.isNew === false ? "row-unseen" : "row-seen";
                return `${baseClass} ${seenClass}`;
              }}

              onVisibleColumnsChange={handleVisibleColumnsChange}
            />
          </div>

          <BulkUploadModal
            open={BulkModal}
            handleClose={() => {
              setBulkModal(!BulkModal);
            }}
            url={"api/student/bulk-upload-students"}
            action={() => {
              let data = {
                limit: 25,
                page: 1,
              };
              reload(data);
            }}
          />

          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />

          {/* modal for chat window */}
          <StudentChatModal
            handleClose={handleCloseChatModal}
            chatModal={chatModal}
            stdId={stdId}
            Studentlist={Studentlist}
          />

          {/* modal for notes window */}
          <StudentNotesModal
            NoteModal={NoteModal}
            handleClose={handleCloseNoteModal}
            stdId={stdId}
            Studentlist={Studentlist}
          />

          {/* modal for pinned window */}
          <StudentPinnedModal
            pinned={pinned}
            pinnedModal={pinnedModal}
            handleClose={handlePinnedModal}
            stdId={stdId}
            Studentlist={Studentlist}
            isPinedNotes={isPinedNotes}
            onSuccess={({ studentId, isPined, isPinedNotes }) => {
              setData((prevData) => {
                const updated = (prevData || []).map((row) =>
                  String(row.id || row._id) === String(studentId)
                    ? { ...row, isPined, isPinedNotes }
                    : row
                );
                return sortStudentList(updated);
              });
              setStudentlist((prevList) => {
                const updated = (prevList || []).map((row) =>
                  String(row.id || row._id) === String(studentId)
                    ? { ...row, isPined, isPinedNotes }
                    : row
                );
                return sortStudentList(updated);
              });
            }}

          />


          {/* modal for reminder window */}
          <StudentReminderModal
            ReminderModal={ReminderModal}
            handleClose={handleCloseReminderModal}
            stdId={stdId}
            // Studentlist={selectionModel}
            Studentlist={Studentlist}
          />

          {/* modal for payment details adding window */}
          <StudentVisaApproveModal
            AddPaymentModal={AddPaymentModal}
            handleClose={handleCloseVisaApproveModal}
            stdId={stdId}
            Studentlist={Studentlist}
          />

          {/* modal for transfering student*/}
          <StudentTransferModal
            TransferModal={TransferModal}
            handleClose={handleCloseTransferModal}
            Agentlist={Agentlist}
            Studentlist={selectionModel}
          />
          <DownloadBulkUploadTemplateModal
            open={uploadTemplateModal}
            handleClose={() => {
              setUploadTemplateModal(!uploadTemplateModal);
            }}
          />
        </>
      )}
    </div>
  );
};

function Studentlist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 0,
      search: searchValue,
    };

    dispatch(GetStudentAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<StudentlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default Studentlist;
